import { render, staticRenderFns } from "./TambahPenjualan.vue?vue&type=template&id=53a8ad6e&"
import script from "./TambahPenjualan.vue?vue&type=script&lang=js&"
export * from "./TambahPenjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports